import {useLocation, useNavigate} from "react-router-dom";
import {PageHeader} from "../../../components/PageHeader";
import React, {useEffect, useMemo, useState} from "react";
import {isEmpty, toKSTISOString} from "../../../components/commonmethod/CommonMethod";
import ApprovalComponent from "../../settings/approval/new/ApprovalComponent";
import {
    clearApprovalProcessState,
    getApprovalProcessSubmitPayload,
    preloadApprovalProcesses,
} from "../../settings/approval/shared/approvalProcessStore";
import Th_title from "../../../components/Th_title";
import {useDispatch, useSelector} from "react-redux";
import {saveDailyCheckReport} from "../../../api/evaluation/DailyCheckReportService";
import {apiLoading} from "../../../redux/slice/apiSlice";
import {dateOnChange} from "../../../components/commonmethod/simmsDateMethod";
import SimmsDatePicker from "../../../components/datepicker/SimmsDatePicker";
import {onCreateClickListener} from "../../../components/commonmethod/simmsDrawerMethod";
import Selector from "../../../components/selector/Selector";
import SimmsInputSearch from "../../../components/input/SimmsInputSearch";
import {
    ContentDetailTwoColLayout,
    DetailFilePanel,
    DetailKvTable,
    DetailListPage,
    DetailPanel,
    DetailSummaryButton,
    DetailSummaryListButton,
} from "../../../components/detailLayout";
import "../../../components/detailLayout/detailListLayout.css";
import {SettingsContentHeroActions} from "../../settings/shared/SettingsContentHeroActions";
import DailyCheckReportItemsPanel from "./DailyCheckReportItemsPanel";

export const checkResult = [
    {value: 0, text: "정상"},
    {value: 1, text: "비정상"},
    {value: 2, text: "미확인"},
];

function DailyCheckReportCreate() {
    const today = new Date();

    const [dailyCheckReport, setDailyCheckReport] = useState({checkDate: toKSTISOString(today)});
    const [list, setList] = useState([]);
    const [docs, setDocs] = useState([]);

    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const approvalProcessId = useSelector((state) => state.content.approvalProcess?.id);

    useEffect(() => {
        clearApprovalProcessState(dispatch);
        return () => clearApprovalProcessState(dispatch);
    }, [dispatch]);

    const requireds = ["checkDate", "dailyCheck"];

    const create = async () => {
        if (requireds.some(e => isEmpty(dailyCheckReport[e]))) {
            alert("필수값이 누락되었습니다.");
            return;
        }

        dispatch(apiLoading(true));

        const docFile = [];
        docs.forEach(each => docFile.push(each.object));

        const finalData = {
            ...dailyCheckReport,
            children: list,
            ...getApprovalProcessSubmitPayload(),
        };

        const response = await saveDailyCheckReport(finalData, docFile);

        if (response.status === 200) {
            alert("등록되었습니다.");
            navigate(`/evaluation/dailyCheck/${response.data.id}`, {
                state: {test: location.state},
            });
        }

        dispatch(apiLoading(false));
    };

    const handleCreate = () => {
        if (window.confirm("등록 하시겠습니까?")) {
            create();
        }
    };

    useEffect(() => {
        setList([]);

        if (dailyCheckReport?.dailyCheck) {
            setList(dailyCheckReport.dailyCheck.children.map(each => ({
                ...each,
                result: 0,
            })));
            preloadApprovalProcesses(dispatch, {
                beforeId: dailyCheckReport.dailyCheck?.approvalProcessId,
            });
        } else {
            clearApprovalProcessState(dispatch);
        }
    }, [dailyCheckReport.dailyCheck, dispatch]);

    function handleInputChange(value, index, target) {
        setList((prevData) =>
            prevData.map((dataItem, dataIndex) => {
                if (dataIndex === index) {
                    return {...dataItem, [target]: value};
                }
                return dataItem;
            })
        );
    }

    const headerActions = (
        <SettingsContentHeroActions>
            <DetailSummaryListButton url="/evaluation/dailyCheck">취소</DetailSummaryListButton>
            <DetailSummaryButton onClick={handleCreate}>등록</DetailSummaryButton>
        </SettingsContentHeroActions>
    );

    const itemsPanelTitle = useMemo(
        () => dailyCheckReport.dailyCheck?.name || "체크항목",
        [dailyCheckReport.dailyCheck?.name],
    );

    return (
        <div className="common-container container-height-full border-l-gray detail-list-layout asset-detail-list-layout flex min-h-0 flex-1 flex-col">
            <PageHeader
                header="일일체크현황"
                indicator="평가관리/보고서 > 업무보고서 > 일일체크현황 > 등록"
                headerActions={headerActions}
            />

            <DetailListPage isEditing className="flex min-h-0 flex-1 flex-col">
                <div className="container-height-body asset-detail-body detail-list-body flex min-h-0 flex-1 flex-col overflow-hidden">
                    <ContentDetailTwoColLayout
                        main={
                            <>
                                <DetailPanel title="점검내용">
                                    <DetailKvTable>
                                        <tbody>
                                        <tr>
                                            <Th_title title="체크일자" colspan={3} className="fieldset-td" required auth>
                                                <SimmsDatePicker
                                                    onChange={(v) => dateOnChange(setDailyCheckReport, "checkDate", v, true)}
                                                    data={dailyCheckReport.checkDate}
                                                />
                                            </Th_title>
                                        </tr>
                                        <tr>
                                            <Th_title title="일일체크코드" colspan={3} className="fieldset-td" auth required>
                                                <Selector
                                                    onChange={(v) => onCreateClickListener(setDailyCheckReport, "dailyCheck", dailyCheckReport.dailyCheck, v)}
                                                    data={dailyCheckReport.dailyCheck}
                                                    entity="dailyCheck"
                                                    uniqueKey="dailyCheck"
                                                >
                                                    <SimmsInputSearch type="TEXT" placeHolder="일일체크코드명"/>
                                                </Selector>
                                            </Th_title>
                                        </tr>
                                        </tbody>
                                    </DetailKvTable>
                                </DetailPanel>

                                <DailyCheckReportItemsPanel
                                    title={itemsPanelTitle}
                                    list={list}
                                    mode="create"
                                    editable
                                    onInputChange={handleInputChange}
                                />
                            </>
                        }
                        aside={
                            <>
                                <ApprovalComponent auth approvalProcessId={approvalProcessId}/>
                                <DetailFilePanel
                                    title="파일"
                                    isEditing
                                    pendingFiles={{files: docs, setFiles: setDocs}}
                                    pendingInputId="daily_check_report_create_doc"
                                />
                            </>
                        }
                    />
                </div>
            </DetailListPage>
        </div>
    );
}

export {DailyCheckReportCreate};
